module.exports = __webpack_public_path__ + "img/buddy_ears-05.7339ad89.svg";